import styled from 'styled-components';

// Import styles
import { flex } from 'components/styles';

export const Segment = styled.div`
	${flex()}
`;
